import { ShipmentsTableState } from './shipments-table.state';
import { Action, createReducer, on } from '@ngrx/store';
import {
    shipmentTableChangePage,
    shipmentTableChangeQuery,
    shipmentTableFailure,
    shipmentTableMasterToggle,
    shipmentTableRequest,
    shipmentTableSetColumns,
    shipmentTableSetSelection,
    shipmentTableSort,
    shipmentTableSuccess,
    shipmentTableToggle,
    shipmentTableUpdateComplete,
    shipmentTableUpdateFailure,
    shipmentTableUpdatePreSelectedQuote,
    shipmentTableUpdateStatuses
} from './shipments-table.actions';
import { ShipmentStatusEnum } from '../../enum/shipment-status.enum';
import { defaultShipmentViews } from '../../constants/default-shipment-views';

const initialState: ShipmentsTableState = {
    query: { ...defaultShipmentViews.ACTIVE_SHIPMENTS.query },
    page: [],
    selection: [],
    totalCount: null,
    filteredCount: null,
    busy: false,
    error: false,
    columns: [ 'COURIER', 'SHIPMENT_STATUS', 'SHIPMENT_DATE', 'SHIPPER_ORGANIZATION', 'SHIPPER_CITY', 'DESTINATION_ORGANIZATION', 'DESTINATION_CITY' ],
    updatingShipments: []
};

const reducer = createReducer(
    initialState,
    on(shipmentTableRequest, (state) => ({
        ...state,
        busy: true,
        page: [ ...state.page ],
        query: { ...state.query },
        error: false
    })),
    on(shipmentTableSuccess, (state, { totalCount, page }) => ({
        ...state,
        busy: false,
        page,
        totalCount,
        query: { ...state.query },
        error: false
    })),
    on(shipmentTableFailure, (state) => ({
        ...state,
        busy: false,
        error: true,
        page: [ ...state.page ],
        query: { ...state.query }
    })),
    on(shipmentTableChangePage, (state, { pageNumber, itemsPerPage }) => ({
        ...state,
        selection: [],
        page: [ ...state.page ],
        query: { ...state.query, pageNumber, itemsPerPage }
    })),
    on(shipmentTableChangeQuery, (state, { query }) => ({
        ...state,
        selection: [],
        query: { ...query, pageNumber: 1, itemsPerPage: query.itemsPerPage ? query.itemsPerPage : state.query.itemsPerPage }
    })),
    on(shipmentTableSetSelection, (state, { ids }) => ({
        ...state,
        selection: [ ...ids ]
    })),
    on(shipmentTableToggle, (state, { id }) => ({
        ...state,
        selection: state.selection.indexOf(id) === -1 ? [ ...state.selection, id ] : state.selection.filter((sid) => sid !== id)
    })),
    on(shipmentTableMasterToggle, (state) => ({
        ...state,
        selection: state.selection.length === 0 ? state.page.map(h => h.id) : []
    })),
    on(shipmentTableSort, (state, { id, descending }) => ({
        ...state,
        query: { ...state.query, sortColumn: id, sortDescending: descending }
    })),
    on(shipmentTableSetColumns, (state, { columns }) => ({
        ...state,
        columns
    })),
    on(shipmentTableUpdatePreSelectedQuote, (state, { shipmentId, quoteId }) => ({
        ...state,
        updatingShipments: [ ...state.updatingShipments, shipmentId ]
    })),
    on(shipmentTableUpdateComplete, (state, { shipmentId }) => ({
        ...state,
        updatingShipments: [ ...state.updatingShipments.filter(id => id !== shipmentId) ]
    })),
    on(shipmentTableUpdateFailure, (state, { shipmentId }) => ({
        ...state,
        updatingShipments: [ ...state.updatingShipments.filter(id => id !== shipmentId) ]
    })),
    on(shipmentTableUpdateStatuses, (state, { shipmentIds, newState }) => ({
        ...state,
        page: state.page.map(s => ({
            ...s,
            status: shipmentIds.indexOf(s.id) === -1 ? s.status : newState
        }))
    }))
);

export function shipmentsTableReducer(state: ShipmentsTableState | undefined, action: Action): any {
    return reducer(state, action);
}
